import React from 'react';
import { HeaderType, TopMenuType } from './HeaderType';
import TopMenu from './TopMenu';
import './header.scss';
import Detail from './Detail';

function Header(props: TopMenuType) {
  const { title, showMenuDot } = props;
  return (
    <>
      <TopMenu title={title} showMenuDot={showMenuDot} />
    </>
  );
}

export default Header;
